module.exports = __webpack_public_path__ + "static/img/2.84f8f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/2.png
// module id = Seie
// module chunks = 10